import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const bookingSupplierConfirmationQuery = graphql(`
  query BookingSupplierConfirmation($id: ID!) {
    bookingSupplierConfirmation(id: $id) {
      id
      status
      source
      booking_reference
      supplier_reference
      email_from
      email_subject
      email_received_at
      failure_reason
      checks {
        type
        outcome
        expected
        actual
      }
      pdf {
        id
        url
      }
      booking {
        id
        reference
        status
        name
        relocation {
          supplier {
            id
            name
          }
        }
      }
    }
  }
`);

export type BookingSupplierConfirmationRecord = ResultOf<
  typeof bookingSupplierConfirmationQuery
>["bookingSupplierConfirmation"];
